exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-to-top-fade-enter-active,.back-to-top-fade-leave-active{transition:opacity .7s}.back-to-top-fade-enter,.back-to-top-fade-leave-to{opacity:0}.vue-back-to-top{position:fixed;z-index:1000;cursor:pointer}.vue-back-to-top .default{width:160px;color:#fff;text-align:center;line-height:30px;background-color:#f5c85c;border-radius:3px}.vue-back-to-top .default span{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35a58e08","scoped":false,"hasInlineConfig":false}!./node_modules/vue-backtotop/src/styles.css
// module id = 423
// module chunks = 0